var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c("a-table", {
        attrs: {
          size: "middle",
          columns: _vm.columns,
          "data-source": _vm.tableData,
          loading: _vm.loading,
          "row-key": function(record, index) {
            return record.id
          },
          bordered: "",
          pagination: false,
          locale: { emptyText: "暂无数据" }
        },
        scopedSlots: _vm._u([
          {
            key: "sort",
            fn: function(text, record, index) {
              return [_vm._v("\n      " + _vm._s(index + 1) + "\n    ")]
            }
          },
          {
            key: "name",
            fn: function(text, record) {
              return [
                record.required
                  ? _c("span", { staticClass: "text-color-orange" }, [
                      _vm._v("*")
                    ])
                  : _vm._e(),
                _vm._v("\n      " + _vm._s(text) + "\n    ")
              ]
            }
          },
          {
            key: "remark",
            fn: function(text, record) {
              return [
                _vm._v("\n      " + _vm._s(text) + "\n      "),
                record.template
                  ? _c(
                      "a",
                      {
                        staticClass: "remark-a",
                        on: {
                          click: function($event) {
                            return _vm.downloadFile(record.template)
                          }
                        }
                      },
                      [_vm._v("\n        模板下载\n      ")]
                    )
                  : _vm._e()
              ]
            }
          },
          {
            key: "oper",
            fn: function(text, record, index) {
              return [
                _c("fileUpload", {
                  ref: "bankFile" + record.id,
                  attrs: {
                    accept: ".pdf,.PDF,.jpg,.JPG,.png,.PNG,.bmp,.BMP",
                    className: "fnc-file",
                    paramObj: _vm.bankFileParam,
                    removeaction: true,
                    hideButtonHasFiles: true,
                    name: "file"
                  },
                  on: {
                    "update:paramObj": function($event) {
                      _vm.bankFileParam = $event
                    },
                    "update:param-obj": function($event) {
                      _vm.bankFileParam = $event
                    },
                    uploadOk: function($event) {
                      return _vm.uploadOkRelated($event, record, index)
                    },
                    beforeFileUpload: function($event) {
                      return _vm.beforeUploadRelated($event, record, index)
                    },
                    handleFileRemove: function($event) {
                      return _vm.handleFileRemove($event, record, index)
                    }
                  }
                })
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "text-color-orange",
          staticStyle: { "margin-top": "16px" }
        },
        _vm._l(_vm.bankFilingRemark, function(remark, index) {
          return _c(
            "div",
            { key: index, style: index > 0 ? "padding-left:29px" : "" },
            [
              index == 0 ? _c("span", [_vm._v("注：")]) : _vm._e(),
              _vm._v(_vm._s(index + 1) + "、" + _vm._s(remark) + "\n    ")
            ]
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26c25230", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26c25230","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bank/bank-step-supplement.vue
// module id = hjBJ
// module chunks = 1